import React from "react";
import { Modal } from "antd";
import { LuX } from "react-icons/lu";

const PanelUserEmailConflictModal = ({
  visible,
  onClose,
  conflicts = [],
  eligibleUsers = [],
  showRemoveButton = true,
  onRemoveUsedAndSend,
  isSending = false,
}) => {
  const conflictCount = conflicts.length;
  const eligibleCount = eligibleUsers.length;
  const hasSingleConflict = conflictCount === 1;
  const hasSingleEligible = eligibleCount === 1;

  const title =
    eligibleCount > 0
      ? hasSingleConflict
        ? "Review panel user before sending"
        : "Review panel users before sending"
      : hasSingleConflict
        ? "Panel user cannot receive this link"
        : "Panel users cannot receive this link";

  const description =
    eligibleCount > 0
      ? hasSingleConflict
        ? "The selected panel user cannot receive this form link. Review the lists below before continuing."
        : "Some selected panel users cannot receive this form link. Review the lists below before continuing."
      : hasSingleConflict
        ? "The selected panel user cannot receive this form link because it is already assigned to them or has already been submitted."
        : "The selected panel users cannot receive this form link because it is already assigned to them or has already been submitted.";

  return (
  <Modal
    open={visible}
    onCancel={onClose}
    footer={null}
    width={520}
    title={null}
    closeIcon={
      <div className="bg-secondary z-10 flex h-8 w-8 items-center justify-center rounded-full">
        <LuX className="text-red-400" size={20} />
      </div>
    }
    className="panel-user-email-conflict-modal"
    destroyOnClose
    centered
  >
    <div className="py-2">
      <h3 className="mb-2 text-lg font-semibold text-gray-900">{title}</h3>
      <p className="mb-4 text-sm text-gray-600">{description}</p>

      <div className="mb-4">
        <h4 className="mb-2 text-sm font-semibold text-gray-900">
          {hasSingleConflict
            ? "Cannot receive link"
            : `Cannot receive link (${conflictCount})`}
        </h4>
        <div className="max-h-48 space-y-3 overflow-y-auto rounded-xl border border-gray-200 bg-gray-50 p-3">
          {conflicts.map((conflict) => (
            <div
              key={`${conflict.rowId}-${conflict.email}`}
              className="rounded-lg bg-white px-3 py-2"
            >
              {conflict.email ? (
                <span className="text-sm text-gray-500">{conflict.email}</span>
              ) : null}
            </div>
          ))}
        </div>
      </div>

      {eligibleUsers.length > 0 ? (
        <div className="mb-4">
          <h4 className="mb-2 text-sm font-semibold text-gray-900">
            {hasSingleEligible
              ? "Valid email"
              : `Valid emails (${eligibleCount})`}
          </h4>
          <div className="max-h-48 space-y-3 overflow-y-auto rounded-xl border border-green-200 bg-green-50 p-3">
            {eligibleUsers.map((user) => (
              <div
                key={`${user.rowId || "unknown"}-${user.email}`}
                className="rounded-lg bg-white px-3"
              >
                {user.email ? (
                  <span className="text-sm text-gray-500">{user.email}</span>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className={`mt-5 flex gap-3 ${showRemoveButton ? "" : "justify-center"}`}>
        <button
          type="button"
          onClick={onClose}
          disabled={isSending}
          className={`h-10 rounded-2xl border btnSecondary text-sm font-medium text-gray-700 disabled:opacity-60 ${
            showRemoveButton ? "w-[50%]" : "w-full"
          }`}
        >
          Close
        </button>
        {showRemoveButton ? (
          <button
            type="button"
            onClick={onRemoveUsedAndSend}
            disabled={isSending}
            className="h-10 w-[50%] rounded-2xl border-0 bg-[#18181B] text-sm font-medium text-white disabled:opacity-60"
          >
            {isSending ? "Sending..." : "Remove used emails from the list"}
          </button>
        ) : null}
      </div>
    </div>
  </Modal>
  );
};

export default PanelUserEmailConflictModal;
